import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { Router } from '@angular/router';
import { User } from '@admin/models/User.model';
import { plainToClass } from 'class-transformer';
import { Campaign } from '@admin/models/Campaign.model';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private loggedInSubject = new BehaviorSubject<boolean>(false);
  private profileSubject = new BehaviorSubject<boolean>(false);
  private campaignSubject = new BehaviorSubject<boolean>(false);

  loggedIn$: Observable<boolean> = this.loggedInSubject.asObservable();
  profile$: Observable<boolean> = this.profileSubject.asObservable();
  _user: User | null = null;

  campaign$: Observable<boolean> = this.campaignSubject.asObservable();
  _campaign: Campaign | null = null;

  constructor(private storage: LocalStorageService, private router: Router) {}

  get profile(): User | null {
    return this._user;
  }

  set profile(value: any) {
    this._user = value ? plainToClass(User, value) : null;

    if (this._user) {
      this.profileSubject.next(true);
    }
  }

  get logged(): boolean {
    const token = this.getToken();

    return token && token.length > 0 ? true : false;
  }

  // TOKEN KEY
  getToken(): string {
    return this.storage.get<string>('token') ?? '';
  }

  setToken(token: string) {
    this.storage.set('token', token);
    this.loggedInSubject.next(true);
  }

  get campaign(): Campaign | null {
    return this._campaign;
  }

  set campaign(value: any) {
    this._campaign = value ? plainToClass(Campaign, value) : null;

    if (this._campaign) {
      this.campaignSubject.next(true);
    }
  }

  clearSession() {
    this.setToken('');
    this.loggedInSubject.next(false);
    this.storage.cleanStorage();
    this.router.navigate(['/']);
  }
}
